import { gql } from '@apollo/client'

import Order from '../../fragments/order'

export const GET_ORDERS_QUERY = gql`
  query GetOrders($search: String) {
    orders(search: $search) {
      id
      orderNumber
      createdOn
      deliveryDate
      quantity
      customer {
        firstName
        lastName
      }
      company
      pages {
        total
        color
        blackAndWhite
      }
    }
    isSuperAdmin
  }
`

export const GET_DELIVERY_ADDRESS_QUERY = gql`
  query GetDeliveryAddress($id: String!) {
    order(id: $id) {
      orderNumber
      approvalDate
      phoneNumbers
      quitProofCopy
      ...OrderDeliveryAddress
    }
  }
  ${Order.fragments.deliveryAddress}
`

export const GET_INVOICE_ADDRESS_QUERY = gql`
  query GetInvoiceAddress($id: String!) {
    order(id: $id) {
      orderNumber
      approvalDate
      phoneNumbers
      ...OrderInvoiceAddress
    }
  }
  ${Order.fragments.invoiceAddress}
`

export const GET_DELIVERY_DATE_QUERY = gql`
  query GetDeliveryDate($id: String!) {
    order(id: $id) {
      id
      deliveryDate
      quitProofCopy
      approvalDate
      latestPrintDataUploadDate
      plannedApprovalDate
    }
  }
`

export const GET_QUIT_PROOF_COPY = gql`
  query GetQuitProofCopy($id: String!) {
    order(id: $id) {
      id
      quitProofCopy
    }
  }
`

export const GET_APPROVAL_DATE_QUERY = gql`
  query GetApprovalQuery($id: String!) {
    order(id: $id) {
      approvalDate
    }
  }
`

export const GET_SPECS_QUERY = gql`
  query GetSpecs($id: String!) {
    order(id: $id) {
      pages {
        color
        blackAndWhite
        total
      }
      sponsoringAds {
        title
        grossAmount
      }
      discounts {
        title
        grossAmount
      }
      extraServices {
        title
        grossAmount
      }
      finalPrice
      quantity
      package
      approvalDate
      id
    }
  }
`

export const GET_ORIGINAL_SPECS_QUERY = gql`
  query GetOriginalSpecs($orderId: String!) {
    orderSpecsByOrderId(orderId: $orderId) {
      orderId
      finalPrice
      books
      bnw
      color
      log {
        finalPrice
        books
        bnw
        color
        createdBy
      }
    }
  }
`

export const GET_PAGES_AND_QUANTITY_QUERY = gql`
  query GetPagesAndQuantity($id: String!) {
    order(id: $id) {
      quantity
      pages {
        color
        blackAndWhite
        total
      }
      grammage
      format
      cover
      coloring
      package
      approvalDate
      id
      orderNumber
      customer {
        firstName
        lastName
      }
      company
      phoneNumbers
    }
  }
`

export const GET_PAGES_AND_COVER_TYPE = gql`
  query GetPagesAndCoverType($id: String!) {
    order(id: $id) {
      pages {
        total
      }
      cover
    }
  }
`

export const GET_ORDER_BY_ID_QUERY = gql`
  query GetOrderById($id: String!) {
    order(id: $id) {
      id
      orderNumber
      pages {
        color
        blackAndWhite
        total
      }
      grammage
      format
      cover
      coloring
      package
      customer {
        firstName
        lastName
      }
      company
      createdOn
      deliveryDate
      quantity
      quitProofCopy
      sponsoringAds {
        title
        grossAmount
      }
      discounts {
        title
        grossAmount
      }
      extraServices {
        title
        grossAmount
      }
      finalPrice
      proofDataUploadDate
      waitingForApprovalDate
      approvalDate
      latestPrintDataUploadDate
      plannedApprovalDate
      finalDataUploadDate
      proofDataInProductionDate
      phoneNumbers
      ...OrderDeliveryAddress
      ...OrderInvoiceAddress
    }
  }
  ${Order.fragments.deliveryAddress}
  ${Order.fragments.invoiceAddress}
`

export const GET_ORDER_NUMBER = gql`
  query GetOrderNumber($id: String!) {
    order(id: $id) {
      id
      orderNumber
    }
  }
`

export const GET_PROGRESS_BAR_DATA = gql`
  query GetProgressBarData($id: String!) {
    order(id: $id) {
      id
      waitingForApprovalDate
      latestPrintDataUploadDate
      approvalDate
      deliveryDate
    }
  }
`

export const GET_DATA_UPLOAD_FLAG = gql`
  query GetDataUploadFlag($id: String!) {
    order(id: $id) {
      id
      proofDataUploadDate
      finalDataUploadDate
      quitProofCopy
      waitingForApprovalDate
      approvalDate
    }
  }
`

export const GET_STATUS_MESSAGE_DATA = gql`
  query GetStatusMessageData($id: String!) {
    order(id: $id) {
      id
      approvalDate
      finalDataUploadDate
      waitingForApprovalDate
      proofDataUploadDate
      quitProofCopy
      proofDataInProductionDate
    }
    latestPreflightReportById(orderId: $id) {
      isProductionReady
    }
  }
`

export const GET_LATEST_PREFLIGHT_REPORT = gql`
  query getLatestPreflightReport($id: String!) {
    order(id: $id) {
      id
      approvalDate
      quitProofCopy
    }
    latestPreflightReportById(orderId: $id) {
      isProductionReady
      filesDir
      webDavDirName
      datachecker {
        name
      }
      text
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/order/index.js